import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';

import { InvitationRateLimitState, WorkspaceUsers } from '../../../mainApi';
import { WorkspaceMembersCurrent } from './WorkspaceMembersCurrent';
import { WorkspaceMembersInvite } from './WorkspaceMembersInvite';

type WorkspaceMembersDialogProps = {
  open: boolean;
  users: WorkspaceUsers | null;
  isOwner: boolean;
  isLoading: boolean;
  isSaving: boolean;
  error: string | null;
  inviteEmails: string;
  inviteMessage: string;
  inviteOpen: boolean;
  onClose: () => void;
  onInviteOpen: () => void;
  onInviteEmailsChange: (value: string) => void;
  onInviteMessageChange: (value: string) => void;
  onInvite: () => void;
  onRemove: (userId: string) => void;
  invitationRateLimit: InvitationRateLimitState | null;
};

export const WorkspaceMembersDialog = ({
  open,
  users,
  isOwner,
  isLoading,
  isSaving,
  error,
  inviteEmails,
  inviteMessage,
  inviteOpen,
  onClose,
  onInviteOpen,
  onInviteEmailsChange,
  onInviteMessageChange,
  onInvite,
  onRemove,
  invitationRateLimit,
}: WorkspaceMembersDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Workspace members</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}

          {isLoading ? (
            <Stack alignItems="center" sx={{ py: 4 }}>
              <CircularProgress size={28} />
            </Stack>
          ) : (
            <>
              {!inviteOpen && (
                <WorkspaceMembersCurrent
                  users={users}
                  isOwner={isOwner}
                  isSaving={isSaving}
                  onRemove={onRemove}
                />
              )}

              {isOwner && inviteOpen && (
                <WorkspaceMembersInvite
                  isSaving={isSaving}
                  inviteEmails={inviteEmails}
                  inviteMessage={inviteMessage}
                  onInviteEmailsChange={onInviteEmailsChange}
                  onInviteMessageChange={onInviteMessageChange}
                  onInvite={onInvite}
                  rateLimit={invitationRateLimit}
                />
              )}
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        {isOwner && !isLoading && !inviteOpen && (
          <Button variant="contained" onClick={onInviteOpen} disabled={isSaving}>
            Invite members
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
